import React from "react";

import { toast } from "react-toastify";

import { copyToClipboard } from "@utils";

import { Button } from "@ui/elements";
import { Stack } from "@ui/layout";

import { useMatchDetails } from "@components";

export const AdminActions = () => {
  const { fixture } = useMatchDetails();

  const copyId = () => {
    toast.promise(() => copyToClipboard(fixture.fixture.id), {
      success: "Copied to clipboard 👌",
    });
  };

  return (
    <Stack>
      <Button variant="light" onClick={copyId}>
        <span>Fixture ID</span>
      </Button>
    </Stack>
  );
};
